import React, { useEffect, useState } from "react";
import { api, formatApiErrorDetail } from "../lib/api";
import { Button } from "./ui/button";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "./ui/dialog";
import { Label } from "./ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";
import { toast } from "sonner";

const MODULES = [
  ["dashboard", "Dashboard"],
  ["master_linen_stock", "Master Linen Stock"],
  ["store_inventory", "Store Inventory"],
  ["purchase_register", "Purchase Register"],
  ["asset_management", "Asset Management"],
  ["audit_log", "Audit Log"],
];

export const ModuleAccessDialog = ({ open, onOpenChange, target, onSaved }) => {
  const [values, setValues] = useState({});
  const [defaults, setDefaults] = useState({});
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!open || !target) return;
    api.get(`/users/${target.id}/module-access`)
      .then(({ data }) => {
        setValues(data.overrides || {});
        setDefaults(data.effective || {});
      })
      .catch(error => toast.error(formatApiErrorDetail(error.response?.data?.detail)));
  }, [open, target]);

  const save = async () => {
    if (!target) return;
    setBusy(true);
    try {
      await api.put(`/users/${target.id}/module-access`, { permissions: values });
      toast.success("Module access updated. The user's session has been refreshed for security.");
      onSaved();
      onOpenChange(false);
    } catch (error) {
      toast.error(formatApiErrorDetail(error.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-xl" data-testid="module-access-dialog">
        <DialogHeader>
          <DialogTitle>Module Access — {target?.name || target?.email}</DialogTitle>
        </DialogHeader>
        <div className="space-y-3">
          {MODULES.map(([key, label]) => (
            <div className="grid grid-cols-[1fr_160px] items-center gap-3" key={key}>
              <Label>{label}</Label>
              <Select
                value={values[key] || defaults[key] || "none"}
                onValueChange={value => setValues({ ...values, [key]: value })}
              >
                <SelectTrigger data-testid={`module-access-${key}`}>
                  <SelectValue />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="none">No Access</SelectItem>
                  <SelectItem value="view">View Only</SelectItem>
                  <SelectItem value="manage">Manage</SelectItem>
                </SelectContent>
              </Select>
            </div>
          ))}
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)} data-testid="module-access-cancel">
            Cancel
          </Button>
          <Button onClick={save} disabled={busy} data-testid="module-access-save">
            {busy ? "Saving…" : "Save access"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};